import React from 'react';
type Tone = 'dark' | 'navy' | 'light' | 'white';
type SectionProps = {
  tone?: Tone;
  id?: string;
  children: React.ReactNode;
  narrow?: boolean;
};
const toneClasses: Record<Tone, string> = {
  dark: 'bg-ink text-white',
  navy: 'bg-navy text-white',
  light: 'bg-paper text-ink',
  white: 'bg-white text-ink'
};
export function Section({
  tone = 'light',
  id,
  children,
  narrow = false
}: SectionProps) {
  return <section id={id} className={`w-full px-5 py-16 sm:px-8 sm:py-24 ${toneClasses[tone]}`} data-id="element-420" data-mp="35tnlzvr7k6p5">
      <div className={`mx-auto w-full ${narrow ? 'max-w-3xl' : 'max-w-6xl'}`} data-id="element-421" data-mp="30usxqeah1pxn">{children}</div>
    </section>;
}
type EyebrowProps = {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
};
export function Eyebrow({
  children,
  tone = 'light'
}: EyebrowProps) {
  return <p className={`font-display text-xs font-bold uppercase tracking-[0.16em] sm:text-sm ${tone === 'dark' ? 'text-accent' : 'text-accent-strong'}`} data-id="element-422" data-mp="1kh2nepsre5fk">
      {children}
    </p>;
}
type HeadingProps = {
  children: React.ReactNode;
  className?: string;
};
export function H2({
  children,
  className = ''
}: HeadingProps) {
  return <h2 className={`font-display text-[30px] font-extrabold leading-[1.1] tracking-tight sm:text-5xl ${className}`} data-id="element-423" data-mp="29i9yvwlfzgu9">
      {children}
    </h2>;
}